import Typography from "@portal/components/atoms/v2/typography";
import { GetIconForRiskPage } from "../../helpers";
import { RadioGroup } from "@headlessui/react";
import RadioComponentWithSelectionBox from "@portal/components/atoms/v2/radioComponentWithSelectionBox";

interface Props {
  optionsTexts: string[];
  optionsHeaders: string[];
  selectedItem: number | null;
  onSelectionClick: (selectedOption: number) => void;
}

export const RiskOptions = ({ optionsTexts, optionsHeaders, selectedItem, onSelectionClick }: Props) => (
  <div className="flex flex-col my-2">
    <RadioGroup value={selectedItem ?? undefined} onChange={onSelectionClick} className="space-y-3">
      {optionsHeaders.map((text, i) => (
        <RadioComponentWithSelectionBox key={i} value={i} id={i.toString()} hideRadio smallPadding>
          {GetIconForRiskPage(i)}
          <div className="flex flex-col p-1">
            <Typography variant="Bold">{text}</Typography>
            <Typography variant="Body">{optionsTexts[i]}</Typography>
          </div>
        </RadioComponentWithSelectionBox>
      ))}
    </RadioGroup>
  </div>
);
